// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".21734a91f8f284c64710ecf09276ef08a52e12e0.chunk.bundle.js";
};